export default {
  namespaced: true,
  state: {
    abcId: "",
    abcAddress: "",
    abcName: "",
    aboPhone: "",
  },
  mutations: {
    reset(state) {
      state.abcId = "";
      state.abcAddress = "";
      state.abcName = "";
      state.aboPhone = "";
    },
    updateAbcId(state, value = "") {
      console.log("updateAbcId Called", value)
      state.abcId = value;
    },
    updateAbcAddress(state, value = "") {
      console.log("updateAbcAddress Called", value)
      state.abcAddress = value;
    },
    updateAbcName(state, value = "") {
      console.log("updateAbcName Called", value)
      state.abcName = value;
    },
    updateAboPhone(state, value = "") {
      state.aboPhone = value;
    }
  },
  getters: {
    pickUpAboPhone(state) {
      return state.aboPhone;
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/pickup.js